module.exports = __webpack_public_path__ + "static/media/54_A.d83c72cd.png";